import { io } from "socket.io-client";
import { URL } from "./api";


//Not in use due to the issue with the order of connection matters.
//With using this, the backend can connect, but the frontend cannot accept connections
//because the frontend connection event is built after the chat page loads(with useEffect) which is to late.
export const socket = io(URL);
